export default __webpack_public_path__ + "tutorial-3@2x.0bf7264d.png";